import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'plataformasPipe',
})
export class PlataformasPipe implements PipeTransform {

  transform(items: any[], filter: any[]) {

    if (filter['id_plataforma'] && !filter['has_search']) {

      items = items.filter((item) => item.id_plataforma == filter['id_plataforma']);
    }

    return items;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/plataformas/plataformas.ts